import { Spinner } from '@chakra-ui/react'
import React from 'react'

export const SpinnerWrapper = (props) => {
    return (
        <>
            {props.isLoading ? <Spinner /> : props.children}
        </>
    )
}
